// Lib
import React from 'react';
import { useTranslator } from '../../components/i18n/useTranslator';
import PropTypes from 'prop-types';

// Components
import FullScreenErrorModal from '../../components/modal/FullScreenErrorModal';
import ModalActionsList from '../../components/modal/ModalActionsList';

const PlatformUnsupportedFullScreenWarning = (props) => {
    const translate = useTranslator('modal', 'platform.unsupported');
    const actions = [
        { text: translate('chromeInstallLink', 'Install Google Chrome instead...'), href: 'https://www.google.com.au/chrome/' },
        { text: translate('continueButton', 'Continue anyway'), func: props.acknowledgeUnsupportedBrowser },
    ];

    return (
        <FullScreenErrorModal>
            <h2>{translate('title', 'Sorry, your browser isn\'t supported yet')}</h2>
            <p className="explanation">
                {translate('description', 'Your browser is missing some features required to run Milanote.')}
                <br />
                {translate('recommendation', 'We recommend upgrading your browser or installing a modern browser like Google Chrome.')}
            </p>
            <ModalActionsList actions={actions} />
        </FullScreenErrorModal>
    );
};

PlatformUnsupportedFullScreenWarning.propTypes = {
    acknowledgeUnsupportedBrowser: PropTypes.func.isRequired,
};

export default PlatformUnsupportedFullScreenWarning;
